import React, { useState, useEffect, useRef } from "react";

function prependZero(num) {
  if (num.toString().length == 1) {
    num = "0" + num;
  }
  return num;
}

function formatTime(seconds) {
  // format second into mm:ss display text
  let mins = Math.floor(seconds / 60);
  let secs = seconds % 60;

  mins = prependZero(mins);
  secs = prependZero(secs);

  return `${mins}:${secs}`;
}

export default function Timer(props) {
  return <div style={{ fontWeight: "bold" }}>{formatTime(props.timer)}</div>;
}
